export default "<div class=\"wrapper2\">\n  <router-outlet></router-outlet>\n</div>"